import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: '[tdWbLinearListItemTemplate]'
})
export class LinearListItemTemplateDirective {
  readonly templateRef: TemplateRef<unknown> = inject(TemplateRef);
}
